import { useEffect, useState } from 'react';

// matchMedia, not window.innerWidth: on rotation iOS WebKit can fire its last resize while
// innerWidth still holds the old width (measured on the iPhone Duo), and nothing re-reads it.
export const useIsMobile = ({ breakpoint = 940 }: { breakpoint?: number } = {}) => {
  const query = `(max-width: ${breakpoint}px)`;
  const [isMobile, setIsMobile] = useState(() => window.matchMedia(query).matches);

  useEffect(() => {
    const media = window.matchMedia(query);
    const handleChange = () => setIsMobile(media.matches);
    handleChange();
    media.addEventListener('change', handleChange);
    return () => {
      media.removeEventListener('change', handleChange);
    };
  }, [query]);

  return isMobile;
};
